import {useMutation, useQueryClient} from "@tanstack/react-query";
import {editMenu, updateMenuStatus} from "../../../store/Menu/api";
import { useHistory } from 'react-router';

export const useUpdateMenuStatus = (slug) => {
    const history = useHistory();
    const queryClient = useQueryClient();

    return useMutation(
        ["updateMenuStatus"],
        ({ body, slug }) => updateMenuStatus({ body, slug }),
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries(["menu-list"]);
                await queryClient.invalidateQueries(["menu-list", slug]);
                history.push(`/chain/menu`)
            },
        }
    );
}
